import * as actionTypes from "../constants/actionTypes";

export function updateCurrentContext(currentContext) {
	return {type: actionTypes.UPDATE_CURRENT_CONTEXT, currentContext};
}
